/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TrackItMeasurementParameterAreaDto } from './TrackItMeasurementParameterAreaDto';
import {
    instanceOfTrackItMeasurementParameterAreaDto,
    TrackItMeasurementParameterAreaDtoFromJSON,
    TrackItMeasurementParameterAreaDtoFromJSONTyped,
    TrackItMeasurementParameterAreaDtoToJSON,
} from './TrackItMeasurementParameterAreaDto';
import type { TrackItMeasurementParameterBooleanDto } from './TrackItMeasurementParameterBooleanDto';
import {
    instanceOfTrackItMeasurementParameterBooleanDto,
    TrackItMeasurementParameterBooleanDtoFromJSON,
    TrackItMeasurementParameterBooleanDtoFromJSONTyped,
    TrackItMeasurementParameterBooleanDtoToJSON,
} from './TrackItMeasurementParameterBooleanDto';
import type { TrackItMeasurementParameterDoubleDto } from './TrackItMeasurementParameterDoubleDto';
import {
    instanceOfTrackItMeasurementParameterDoubleDto,
    TrackItMeasurementParameterDoubleDtoFromJSON,
    TrackItMeasurementParameterDoubleDtoFromJSONTyped,
    TrackItMeasurementParameterDoubleDtoToJSON,
} from './TrackItMeasurementParameterDoubleDto';
import type { TrackItMeasurementParameterLongDto } from './TrackItMeasurementParameterLongDto';
import {
    instanceOfTrackItMeasurementParameterLongDto,
    TrackItMeasurementParameterLongDtoFromJSON,
    TrackItMeasurementParameterLongDtoFromJSONTyped,
    TrackItMeasurementParameterLongDtoToJSON,
} from './TrackItMeasurementParameterLongDto';
import type { TrackItMeasurementParameterModalityDto } from './TrackItMeasurementParameterModalityDto';
import {
    instanceOfTrackItMeasurementParameterModalityDto,
    TrackItMeasurementParameterModalityDtoFromJSON,
    TrackItMeasurementParameterModalityDtoFromJSONTyped,
    TrackItMeasurementParameterModalityDtoToJSON,
} from './TrackItMeasurementParameterModalityDto';
import type { TrackItMeasurementParameterStringDto } from './TrackItMeasurementParameterStringDto';
import {
    instanceOfTrackItMeasurementParameterStringDto,
    TrackItMeasurementParameterStringDtoFromJSON,
    TrackItMeasurementParameterStringDtoFromJSONTyped,
    TrackItMeasurementParameterStringDtoToJSON,
} from './TrackItMeasurementParameterStringDto';

/**
 * @type TrackItMeasurementParameterDto
 * 
 * @export
 */
export type TrackItMeasurementParameterDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterAreaDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItMeasurementParameterAreaDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterBooleanDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItMeasurementParameterBooleanDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterDoubleDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItMeasurementParameterDoubleDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterLongDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItMeasurementParameterLongDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterModalityDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItMeasurementParameterModalityDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterStringDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItMeasurementParameterStringDto;


export function TrackItMeasurementParameterDtoFromJSON(json: any): TrackItMeasurementParameterDto {
    return TrackItMeasurementParameterDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementParameterDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterAreaDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItMeasurementParameterAreaDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterAreaDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterBooleanDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItMeasurementParameterBooleanDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterBooleanDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterDoubleDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItMeasurementParameterDoubleDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterDoubleDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterLongDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItMeasurementParameterLongDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterLongDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterModalityDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItMeasurementParameterModalityDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterModalityDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterStringDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItMeasurementParameterStringDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterStringDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of TrackItMeasurementParameterDto exists with '$type=${json['$type']}'`);
    }
}

export function TrackItMeasurementParameterDtoToJSON(value?: TrackItMeasurementParameterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterAreaDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItMeasurementParameterAreaDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterBooleanDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItMeasurementParameterBooleanDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterDoubleDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItMeasurementParameterDoubleDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterLongDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItMeasurementParameterLongDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterModalityDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItMeasurementParameterModalityDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterStringDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItMeasurementParameterStringDtoToJSON(value);
        default:
            throw new Error(`No variant of TrackItMeasurementParameterDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the TrackItMeasurementParameterDto interface.
 */
export function instanceOfTrackItMeasurementParameterDto(value: any): value is TrackItMeasurementParameterDto {
    if (instanceOfTrackItMeasurementParameterAreaDto(value)) return true;
    if (instanceOfTrackItMeasurementParameterBooleanDto(value)) return true;
    if (instanceOfTrackItMeasurementParameterDoubleDto(value)) return true;
    if (instanceOfTrackItMeasurementParameterLongDto(value)) return true;
    if (instanceOfTrackItMeasurementParameterModalityDto(value)) return true;
    if (instanceOfTrackItMeasurementParameterStringDto(value)) return true;
    return false;
}

